import { Link } from 'react-router-dom';

export default function Footer() {
  return (
    <footer className="bg-slate-950 text-white py-16 relative overflow-hidden">
      {/* Futuristic background pattern */}
      <div className="absolute inset-0 opacity-5">
        <div className="absolute top-0 left-0 w-full h-full bg-gradient-to-br from-blue-500/10 via-indigo-600/5 to-transparent"></div>
        <div className="absolute bottom-0 right-0 w-96 h-96 bg-gradient-to-tl from-blue-500/10 to-transparent blur-3xl"></div>
      </div>
      
      <div className="max-w-7xl mx-auto px-6 lg:px-8">
        <div className="grid md:grid-cols-2 gap-12 mb-12">
          {/* Company Info */}
          <div>
            <div className="flex items-center space-x-3 mb-4">
              <img 
                src="https://static.readdy.ai/image/9314f36c9b0b27794c5d4e89097301d2/2fdc5c933c3f01dbe99c1e4f8cc66af6.jpeg" 
                alt="ClearPath Intelligence" 
                className="h-10 w-auto"
              />
            </div>
            <p className="text-indigo-300 font-medium mb-4 text-lg">
              Your Clear Path to Digital Success
            </p>
            <p className="text-slate-300 mb-6 leading-relaxed">
              ClearPath Intelligence builds modern, high-performance websites for small businesses across the United States. Based in Buffalo, NY, we help companies achieve online visibility through intelligent web design and cutting-edge technology.
            </p>
          </div>

          {/* Contact Info */}
          <div>
            <h3 className="text-white font-semibold text-lg mb-6">Contact Us</h3>
            <ul className="space-y-3">
              <li className="flex items-start text-slate-300">
                <i className="ri-map-pin-line text-indigo-400 mr-3 mt-1"></i>
                <span>Buffalo, NY<br />United States</span>
              </li>
              <li className="flex items-center text-slate-300">
                <i className="ri-phone-line text-indigo-400 mr-3"></i>
                <span>(716) 939-5685</span>
              </li>
              <li className="flex items-center text-slate-300">
                <i className="ri-mail-line text-indigo-400 mr-3"></i>
                <span>Sales@ClearPathIntelligence.net</span>
              </li>
            </ul>
          </div>
        </div>

        {/* Bottom Bar */}
        <div className="border-t border-slate-700/50 pt-8 flex flex-col md:flex-row justify-between items-center space-y-4 md:space-y-0">
          <p className="text-slate-400 text-sm">
            © 2024 ClearPath Intelligence. All rights reserved.
          </p>
          <div className="flex items-center space-x-6">
            <a href="#" className="text-slate-400 hover:text-indigo-400 text-sm transition-colors cursor-pointer">Privacy Policy</a>
            <a href="#" className="text-slate-400 hover:text-indigo-400 text-sm transition-colors cursor-pointer">Terms of Service</a>
            <a href="https://readdy.ai/?ref=logo" target="_blank" rel="noopener noreferrer" className="text-slate-400 hover:text-indigo-400 text-sm transition-colors cursor-pointer">Powered by Readdy</a>
          </div>
        </div>
      </div>
    </footer>
  );
}
